// @flow

import { push } from 'connected-react-router'
import qs from 'qs'
import {
  checkHttpStatus,
  getApiHeaders,
  getApiBaseUrlWithOrg
} from '../utils/api'
import type { APIError } from '../types'
import { getErrorAction } from '../utils/actions'

export const FETCH_MYQUESTS_REQUEST = 'FETCH_MYQUESTS_REQUEST'
export const FETCH_MYQUESTS_SUCCESS = 'FETCH_MYQUESTS_SUCCESS'
export const FETCH_MYQUESTS_FAILURE = 'FETCH_MYQUESTS_FAILURE'
export const FETCH_MYQUEST_PEERS_REQUEST = 'FETCH_MYQUEST_PEERS_REQUEST'
export const FETCH_MYQUEST_PEERS_SUCCESS = 'FETCH_MYQUEST_PEERS_SUCCESS'
export const FETCH_MYQUEST_PEERS_FAILURE = 'FETCH_MYQUEST_PEERS_FAILURE'
export const CLEAR_MYQUESTS = 'CLEAR_MYQUESTS'
export const DECREMENT_FEEDBACK_COUNT = 'DECREMENT_FEEDBACK_COUNT'
export const SET_UNREAD_FEEDBACK_COUNT = 'SET_UNREAD_FEEDBACK_COUNT'
export const SET_LAST_SKILL_ASSESSMENT_AT = 'SET_LAST_SKILL_ASSESSMENT_AT'

export function setLastSkillAssessmentAt(userCompiledQuestId: number): Object {
  return {
    type: SET_LAST_SKILL_ASSESSMENT_AT,
    userCompiledQuestId: userCompiledQuestId
  }
}

export function decrementUnreadFeedbackCount(): Object {
  return {
    type: DECREMENT_FEEDBACK_COUNT
  }
}

export function setUnreadFeedbackCount(count: number): Object {
  return {
    type: SET_UNREAD_FEEDBACK_COUNT,
    count: count
  }
}

export function clearMyQuests(): Object {
  return {
    type: CLEAR_MYQUESTS
  }
}

export function fetchMyQuestsRequest(): Object {
  return {
    type: FETCH_MYQUESTS_REQUEST
  }
}

export function fetchMyQuestsSuccess(
  response: Object,
  fetchActive: boolean
): Object {
  return {
    type: FETCH_MYQUESTS_SUCCESS,
    myquests: response,
    fetchActive: fetchActive
  }
}

export function fetchMyQuestsFailure(error: APIError): Object {
  return getErrorAction(FETCH_MYQUESTS_FAILURE, error)
}

export function fetchMyQuestPeersRequest(): Object {
  return {
    type: FETCH_MYQUEST_PEERS_REQUEST
  }
}

export function fetchMyQuestPeersSuccess(response: Object): Object {
  return {
    type: FETCH_MYQUEST_PEERS_SUCCESS,
    peers: response
  }
}

export function fetchMyQuestPeersFailure(error: APIError): Object {
  return getErrorAction(FETCH_MYQUEST_PEERS_FAILURE, error)
}

export function fetchMyQuests(fetchActive: boolean): Function {
  return async (dispatch, getState) => {
    dispatch(fetchMyQuestsRequest())
    const state = getState()

    try {
      let newFeedbackCount = 0

      const params = qs.stringify({
        q: fetchActive
          ? {
              active: true
            }
          : {
              completed: true
            }
      })

      const response = checkHttpStatus(
        await fetch(
          `${getApiBaseUrlWithOrg(
            state.organization.orgId
          )}/user/user_compiled_quests?${params}`,
          {
            method: 'GET',
            headers: getApiHeaders(state)
          }
        )
      )

      const quests = await response.json()
      dispatch(fetchMyQuestsSuccess(quests, fetchActive))

      if (fetchActive) {
        if (quests && quests.length > 0) {
          newFeedbackCount = quests.filter(
            q => q.unread_notifications_count > 0
          ).length
        }

        dispatch(setUnreadFeedbackCount(newFeedbackCount))
      }
    } catch (error) {
      dispatch(fetchMyQuestsFailure(error))
    }
  }
}

export function fetchMyQuestPeers(id: number): Function {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(fetchMyQuestPeersRequest())

    try {
      const response = checkHttpStatus(
        await fetch(
          `${getApiBaseUrlWithOrg(
            state.organization.orgId
          )}/compiled_quests/${id}/active_users`,
          {
            method: 'GET',
            headers: getApiHeaders(state)
          }
        )
      )

      const peers = await response.json()
      dispatch(fetchMyQuestPeersSuccess(peers))
    } catch (error) {
      dispatch(fetchMyQuestPeersFailure(error))

      if (error.response.status === 404) {
        dispatch(push('/notfound'))
      }
    }
  }
}
